module.exports = __webpack_public_path__ + "img/popup-promo-countdown_mob.772a14ac.jpg";